import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./endpoint-detail-view.html';
import Signals from 'signals';
import MetadataService from "../../../services/metadata.service";
import MessageService from "../../../services/message.service";
import DataProvider from "../../../app/data-framework/data-provider";



    function EndpointDetailView(params) {
        var self = this;

        self.route = params.route;

        self.dataProvider = DataProvider.getInstance();

        self.hiddenTabs = self.dataProvider.assuranceIsInModules() ? [1,3] : [1,2,3];

        var endpointId = self.route().epid ? self.route().epid : 0;

        self.handleAssuranceCalls = function() {
            var unwrappedRoute = ko.unwrap(self.route);
            if((unwrappedRoute.page === 'assurance-app-view' || (unwrappedRoute.page === 'historical2-app-view' && self.dataProvider.assuranceIsInModules())) && unwrappedRoute.tabId === '2') {
                MetadataService.fetchDatasetMetadataWithoutCategories('calls').then(function (metadata){ 
                    // let endpoint_id = metadata.columns.find(col => col.id === 'endpoint_id');
                    // let dataSource = metadata.columns.find(col => col.id === 'data_source');
                    // let systemName = metadata.columns.find(col => col.id === 'system_name');
                    let quality = metadata.columns.find(col => col.id === 'quality');
                    let callType = metadata.columns.find(col => col.id === 'call_type');
                    // let connectionType = metadata.columns.find(col => col.id === 'connection_type');

                    let endpointName = self.title();
                    let filterExpression = {
                        "filterGroups": [{
                            "filters": [
                                {
                                    "id": 0,
                                    "field": "endpoint_id",
                                    "fieldText": "Endpoint",
                                    "type": "number",
                                    "filterComplete": true,
                                    "operatorText": "is",
                                    "operatorValue": "quickPick",
                                    "isQuickPick": true,
                                    "widget": "ids",
                                    "data": {"selections": [{"id": endpointId, "name": endpointName}]},
                                    "quickPickValues": [{"id": endpointId, "name": endpointName}],
                                    "value": "endpoint_id=in=(" + endpointId + ")",
                                    "queryVar": "" + endpointId,
                                    "text": "Endpoint is (" + endpointName + ")",
                                    "shortText": endpointName
                                }, {
                                    "id": 1,
                                    "field": quality.id,
                                    "fieldText": quality.name,
                                    "type": "string",
                                    "filterComplete": true,
                                    "knownValuePath": undefined,
                                    "operatorText": "is",
                                    "operatorValue": "quickPick",
                                    "isQuickPick": true,
                                    "widget": "toggles",
                                    "isQuickStart": true,
                                    "quickPickValues": ["Good", "Fair", "Bad", "Unknown"]
                                },
                                {
                                    "id": 2,
                                    "field": callType.id,
                                    "fieldText": callType.name,
                                    "type": "string",
                                    "filterComplete": true,
                                    "knownValuePath": undefined,
                                    "operatorText": "is",
                                    "operatorValue": "quickPick",
                                    "isQuickPick": true,
                                    "widget": "toggles",
                                    "isQuickStart": true,
                                    "quickPickValues": ["Video", "Audio", "Other"]
                                },
                                // {
                                //     "id": 3,
                                //     "field": connectionType.id,
                                //     "fieldText": connectionType.name,
                                //     "type": "string",
                                //     "filterComplete": true,
                                //     "knownValuePath": undefined,
                                //     "operatorText": "is",
                                //     "operatorValue": "quickPick",
                                //     "isQuickPick": true,
                                //     "widget": "toggles",
                                //     "isQuickStart": true,
                                //     "quickPickValues": ["Wired", "Wifi", "Other"]
                                // },
                                // {
                                //     "id": 4,
                                //     "field": dataSource.id,
                                //     "fieldText": dataSource.name,
                                //     "type": "string",
                                //     "filterComplete": true,
                                //     "knownValuePath": dataSource.knownValuePath,
                                //     "operatorText": "in",
                                //     "operatorValue": "=in=(|)",
                                //     "isQuickPick": false,
                                //     "isQuickStart": true,
                                //     "quickPickValues": undefined
                                // },
                                // {
                                //     "id": 5,
                                //     "field": systemName.id,
                                //     "fieldText": systemName.name,
                                //     "type": "string",
                                //     "filterComplete": true,
                                //     "knownValuePath": systemName.knownValuePath,
                                //     "operatorText": "in",
                                //     "operatorValue": "=in=(|)",
                                //     "isQuickPick": false,
                                //     "isQuickStart": true,
                                //     "quickPickValues": undefined
                                // }
                            ], "operator": "and", "groupId": 0
                        }], "operator": "and"
                    };
                    // todo: figure out how to make this automatic rather than hardcoded
                    window.sessionStorage.setItem('assuranceassurance-calls', JSON.stringify(filterExpression));
                    window.location.replace('#monitoring/calls');
                });
            }
        };

        self.handleAssuranceCalls();

        self.widgetDragDropContainerOptions = {};


        self.dataProvider.loadEndpointHistoricalInfo(endpointId);

        var tabId = self.route().tabId ? self.route().tabId.toString() : '0';
        self.tabId = tabId;
        self.currentTabFixedPanelObservable = ko.observableArray([]);

        this.updateModalSignals = ko.observable({
            showSingleUpdateModal: new Signals.Signal(),
            onUpdateEndpoint: new Signals.Signal(),
        });

        self.title = ko.observable('Endpoint Details');

        self.pageId = tabId === '0' ? 'General' : tabId === '1' ? 'AV' : 'Calls'; // : 'WebexUsers';

        self.currentPanelsObservable = ko.observableArray([]);
        self.viewLevelOptions = ko.observable({ endpointId: endpointId });

        self.subscriptions = [
            self.viewLevelOptions.subscribe(function (val) {
                if (val.title) {
                    self.title(val.title);
                }
            }),
            self.route.subscribe(function() {
                self.handleAssuranceCalls();
            }),
          self.title.subscribe(function(val) {
              MessageService.notifyParentIframeBreadcrumbs(['Endpoint Details', val])
          })
        ];
    }

    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    EndpointDetailView.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });

    };

    export default { viewModel: EndpointDetailView, template: templateMarkup };
